export default __webpack_public_path__ + "static/media/poorly_positioned_camera.62469716.svg";